var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7511296,3.52496318 L5.7511296,2.60957506 C5.7511296,2.45022084 5.62292734,2.32201858 5.46357312,2.32201858 L3.81251966,2.32201858 L3.81251966,0.67096512 C3.81251966,0.511610904 3.6843174,0.38340864 3.52496318,0.38340864 L2.60957506,0.38340864 C2.45022084,0.38340864 2.32201858,0.511610904 2.32201858,0.67096512 L2.32201858,2.32201858 L0.67096512,2.32201858 C0.511610904,2.32201858 0.38340864,2.45022084 0.38340864,2.60957506 L0.38340864,3.52496318 C0.38340864,3.6843174 0.511610904,3.81251966 0.67096512,3.81251966 L2.32201858,3.81251966 L2.32201858,5.46357312 C2.32201858,5.62292734 2.45022084,5.7511296 2.60957506,5.7511296 L3.52496318,5.7511296 C3.6843174,5.7511296 3.81251966,5.62292734 3.81251966,5.46357312 L3.81251966,3.81251966 L5.46357312,3.81251966 C5.62292734,3.81251966 5.7511296,3.6843174 5.7511296,3.52496318 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bf84cf603e50d2e13d452e0b48fc7422.svg";
export { ForwardRef as ReactComponent };